module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-350.a4cdb1c.woff2";